import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import useDeleteQueryItem from '../../../services/api/hooks/useDeleteQueryItem'
import { deleteFormula } from '../service/formulaService'
import { Formula } from '../types/Formula'
import { useFormulaOptions } from './useFormulaOptions'

export const useDeleteFormula = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const options = useFormulaOptions({ companyId })
  const deleteQueryItem = useDeleteQueryItem()

  return useMutation({
    mutationKey: ['budget', 'formula', 'delete'],
    mutationFn: (formulaId: Formula['id']) => deleteFormula(companyId, formulaId),
    onSuccess(item) {
      deleteQueryItem(item, 'id', options)
    }
  })
}
